export default {
	HOME: { path: '*', name: 'Home' },
	DASHBOARD: { path: '/dashboard', name: 'Dashboard' },
	LOGIN: { path: '/login', name: 'Login' },
	FORGOTPWD: { path: '/forgotpassword', name: 'Forgot Password' },
	REGISTRATION: { path: '/registration', name: 'Registration' },
	RESET_PASSWORD: { path: '/reset-password', name: 'Reset Password' },

	USER_PROFILE: { path: '/profile', name: 'User Profile' },
	ADVERTISEMENT_DETAILS: {
		path: '/advertisement',
		name: 'Advertisements Details',
	},
	CREATE_ADVERTISEMENT_DETAILS: {
		path: '/advertisement/create',
		name: 'Create Advertisements Details',
	},
	VIEW_ADVERTISEMENT_DETAILS: {
		path: '/advertisement/view',
		name: 'View Advertisements Details',
	},
	EDIT_ADVERTISEMENT_DETAILS: {
		path: '/advertisement/edit',
		name: 'Advertisements Details',
	},
	CONTENT_LIBRARY: { path: '/contentlibrary', name: 'Content Library' },
	SCREEN_SHOT: { path: '/screenshot', name: 'Screen Shot' },
	REFUND: { path: '/refund', name: 'Refund' },
	CONTENT_GROUP: { path: '/contentgroup', name: 'Content Group' },
	REPORTS: { path: '/reports', name: 'Reports' },

	CAMPAIGN: { path: '/campaign', name: 'Campaign' },

	CAMPAIGN_LIST: { path: '/campaign', name: 'Campaign List' },
	CREATE_CAMPAIGN: { path: '/campaign/create', name: 'Create Campaign' },
	EDIT_CAMPAIGN: { path: '/campaign/edit', name: 'Edit Campaign' },
	VIEW_CAMPAIGN: { path: '/campaign/view', name: 'View Campaign' },
	CAMPAIGN_AUDIT: { path: '/campaign/audit', name: 'Audit Campaign' },
	VIEW_CAMPAIGN_AUDIT: { path: '/campaign/audit/view', name: 'View Campaign Audit' },

	TEMPLATE: { path: '/template', name: 'Template' },
	TEMPLATE_LIST: { path: '/template', name: 'Template List' },
	CREATE_TEMPLATE: { path: '/template/create', name: 'Create Template' },
	EDIT_TEMPLATE: { path: '/template/edit', name: 'Edit Template' },
	VIEW_TEMPLATE: { path: '/template/view', name: 'View Template' },

	FEEDBACK: { path: '/feedback', name: 'Feedback' },
	// REPORTS: { path: '/reports', name: 'Reports' },
};
